import Alpine from 'alpinejs';
import { iodine } from '../../helpers/validation';
import { ExpressQuotationRules } from '../../types/form';
import { getFieldValidation } from '../../helpers/fieldValidation';
import { storeLocatorAutocomplete } from "../../helpers/storeLocator";
import { FormValidation } from '../../types/form';
import { send } from '../../helpers/api';


const rules: ExpressQuotationRules = {
    firstname: ['required', 'noNumber'],
    lastname: ['required', 'noNumber'],
    address: ['required', 'leastOneLetter'],
    zip: ['required', 'zipOrCity'],
    phone: ['required', 'trybaPhone'],
    email: ['required', 'email', 'noPlusInEmail'],
    projectType: ['required'],
    phone_custom: ['required', 'justNumber'],
    city: ['required'],
    zip_no_autocomplete: ['required'],
};

document.addEventListener('alpine:init', () => {
    // @ts-ignore
    Alpine.data('initAppointmentOrQuotationForm', (form: HTMLFormElement):  Any => {
        return {
            ...getFieldValidation(rules),
            ...{
                form,
                buttonDisable: true,
                loading: false,
                validAdress: undefined,
                confirmation: false,
                submitBtn: form.querySelector('button[type="submit"]') as HTMLButtonElement,
                validateAllFields() {
                    const firstname = form.querySelector('[name$="[firstname]"]') as HTMLInputElement;
                    const lastname = form.querySelector('[name$="[lastname]"]') as HTMLInputElement;
                    const zip = form.querySelector('[name$="[zip]"]') as HTMLInputElement;
                    const phone = form.querySelector('[name$="[phone]"]') as HTMLInputElement;
                    const email = form.querySelector('[name$="[email]"]') as HTMLInputElement;
                    const rgpd =  form.querySelector('[name$="[rgpd]"]') as HTMLInputElement;
                    let validAdress = this.validAdress != undefined ? this.validAdress : false;
                    setTimeout(() => {
                        storeLocatorAutocomplete(zip?.value)
                        .then((cities) => {
                            this.results = cities;

                            const allResult = (this.results = JSON.parse(JSON.stringify(this.results)));

                            allResult.forEach((el) => {
                                if (el.codesPostaux.length > 1)
                                    el.codesPostaux.forEach((subEl) => {
                                        const result = subEl + ' ' + el.nom;
                                        if (zip?.value == result) {
                                            validAdress = true;
                                        }
                                    });
                                else {
                                    const result = el.codesPostaux[0] + ' ' + el.nom;
                                    if (zip?.value == result) {
                                        validAdress = true;
                                    }
                                }
                            });
                            this.verifyFields(validAdress,firstname, lastname, zip, phone, email, rgpd);
                        })
                        .catch(() => {
                            this.verifyFields(validAdress, firstname, lastname, zip, phone, email, rgpd);
                        });
                    }, 300)
                    // Check if ZIP is valid

                },
                verifyFields(validAdress, firstname, lastname, zip, phone, email, rgpd) {
                    const validation = iodine.assert(
                        {
                            firstname: firstname?.value,
                            lastname: lastname?.value,
                            zip: validAdress ? zip?.value : null,
                            phone:  phone?.value,
                            email: email?.value,
                            rgpd: rgpd?.value
                        },
                        {
                            firstname: rules.firstname,
                            lastname: rules.lastname,
                            zip: rules.zip,
                            phone: rules.phone,
                            email: rules.email,
                            rgpd: true
                        },
                    );
                    this.checkValidation(validation);

                },
                checkValidation(validation: FormValidation): void {
                    if (validation.valid) {
                        this.buttonDisable = false;
                    } else {
                        this.buttonDisable = true;
                    }
                },
                async submitForm(event) {
                    event.preventDefault();

                    if (this.loading) {
                        return;
                    }

                    if (form) {
                        this.loading = true;
                        this.buttonDisable = true;
                        const formData = new FormData(form);
                        try {
                            await send(formData,form.action);
                            this.confirmation = true;
                        } catch (e) {
                            this.confirmation = false;
                        } finally {
                            this.loading = false;
                            this.buttonDisable = false;
                        }
                    }
                }
            },
        };
    });
});
